<template>
  <footer id="footer" class="pt-5 pb-5">
    <b-container>
      <b-row class="mb-5">
        <b-col align="center">
          <!-- <a
            href="https://www.crazydomains.co.nz/certification/certificate/?token=0c3e250134884e3f887829343dfe2a141633565473"
            target="_blank"
            rel="noopener noreferrer"
            ><img
              id="seal_2_certificate_image"
              src="https://www.crazydomains.co.nz/certification/seal/2/0c3e250134884e3f887829343dfe2a141633565473/"
          /></a>
          &nbsp; -->
          <a
            href="https://www.credly.com/badges/d5b93c47-41b3-43c6-8608-7bf81eeabd69?source=linked_in_profile"
            target="_blank"
            rel="noopener noreferrer"
            ><img
              id="seal_2_certificate_image"
              :src="require('../assets/azure-fundamentals.png')"
          /></a>
        </b-col>
      </b-row>
      <b-row>
        <b-col align="center">
          <p>
            copyright &copy; {{ new Date().getFullYear() }} thegeekyhelper
            &bull; website by thegeekyhelper &mdash; inspired by
            <a
              href="https://github.com/StartBootstrap/startbootstrap-freelancer"
              >StartBootstrap</a
            >
          </p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
footer {
  color: #666;
  background-color: #fff;
}

p {
  font-size: 1rem;
}
</style>
